export const FETCH_TEMPLATES_REQUEST = 'templates/FETCH_TEMPLATES_REQUEST'
export const FETCH_TEMPLATES_SUCCESS = 'templates/FETCH_TEMPLATES_SUCCESS'
export const FETCH_TEMPLATES_FAILURE = 'templates/FETCH_TEMPLATES_FAILURE'

export const FETCH_TEMPLATE_REQUEST = 'templates/FETCH_TEMPLATE_REQUEST'
export const FETCH_TEMPLATE_SUCCESS = 'templates/FETCH_TEMPLATE_SUCCESS'
export const FETCH_TEMPLATE_FAILURE = 'templates/FETCH_TEMPLATE_FAILURE'

export const DELETE_TEMPLATE_REQUEST = 'templates/DELETE_TEMPLATE_REQUEST'
export const DELETE_TEMPLATE_SUCCESS = 'templates/DELETE_TEMPLATE_SUCCESS'
export const DELETE_TEMPLATE_FAILURE = 'templates/DELETE_TEMPLATE_FAILURE'

export const CREATE_TEMPLATE_REQUEST = 'templates/CREATE_TEMPLATE_REQUEST'
export const CREATE_TEMPLATE_SUCCESS = 'templates/CREATE_TEMPLATE_SUCCESS'
export const CREATE_TEMPLATE_FAILURE = 'templates/CREATE_TEMPLATE_FAILURE'

export const UPDATE_TEMPLATE_REQUEST = 'templates/UPDATE_TEMPLATE_REQUEST'
export const UPDATE_TEMPLATE_SUCCESS = 'templates/UPDATE_TEMPLATE_SUCCESS'
export const UPDATE_TEMPLATE_FAILURE = 'templates/UPDATE_TEMPLATE_FAILURE'

export const DOWNLOAD_TEMPLATE_REQUEST = 'properties/DOWNLOAD_TEMPLATE_REQUEST'
export const DOWNLOAD_TEMPLATE_SUCCESS = 'properties/DOWNLOAD_TEMPLATE_SUCCESS'
export const DOWNLOAD_TEMPLATE_FAILURE = 'properties/DOWNLOAD_TEMPLATE_FAILURE'

export const FETCH_TEMPLATE_TAGS_REQUEST =
  'templates/FETCH_TEMPLATE_TAGS_REQUEST'
export const FETCH_TEMPLATE_TAGS_SUCCESS =
  'templates/FETCH_TEMPLATE_TAGS_SUCCESS'
export const FETCH_TEMPLATE_TAGS_FAILURE =
  'templates/FETCH_TEMPLATE_TAGS_FAILURE'

export const FETCH_TEST_TEMPLATE_REQUEST =
  'templates/FETCH_TEST_TEMPLATE_REQUEST'
export const FETCH_TEST_TEMPLATE_SUCCESS =
  'templates/FETCH_TEST_TEMPLATE_SUCCESS'
export const FETCH_TEST_TEMPLATE_FAILURE =
  'templates/FETCH_TEST_TEMPLATE_FAILURE'

export const UPDATE_FIELD = 'templates/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'templates/SET_DEFAULT_DATA'
